export default "__VITE_ASSET__DbUdr6CK__"